export interface IPushNotificationHistoryDisplay {
    PushNotificationHistoryId: number,
    Title: string,
    Body: string,
    ProductSubType: string,
    ParentProductId: number,
    ProductId: number,
    CreatedDate: string,
    ProductReleaseNo: string,
}
export interface IPushNotificationHistoryDTO {
    Title: string,
    Body: string,
    ProductReleaseId: number,
    ProductId: number,
    ParentProductId: number,
    CreatedBy: number
}
export interface IPushNotificationDropDownItem {
    ProductName: string,
    ProductId: number,
    ProductCode: number,
    ProductVariant: number
}
export enum ProductsWithPushNotification {
    "G3"=12,
    "G3-GLT"=41,
    "PMD2"=13,
    "PMD2GLT"=42,
    "PMD2EMEA"=13,
    "LZ-50"=15,
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfaces/PushNotificationHistory.ts